import queryString from "query-string";

export function getSortOrder(key) {
    const params = queryString.parse(window?.location?.search);

    if (params.sort_by !== key)
        return false;
    return params.sort_dir === 'asc' ? 'ascend' : 'descend';
}
